import { useRefinementList } from 'react-instantsearch';

/* eslint-disable-next-line */
export interface SearchRefinementListProps {
    attribute: string;
}

export function SearchRefinementList(props: SearchRefinementListProps) {
    const { attribute } = props;

    const { items, refine } = useRefinementList({
        attribute,
        sortBy: ['name:asc'],
    });

    return (
        <div>
            <ul className="pl-0 list-none">
                {items.map((item) => {
                    return (
                        <li key={item.label} className="mb-4">
                            <label
                                className="flex items-start leading-snug cursor-pointer gtm-search-filter"
                                data-insights-filters={`${attribute}:${item.value}`}
                            >
                                <input
                                    className="mr-2 text-base"
                                    type="checkbox"
                                    checked={item.isRefined}
                                    onChange={() => refine(item.value)}
                                />
                                {item.label}
                            </label>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default SearchRefinementList;
